import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import 'style/index.css';

// eslint-disable-next-line func-names
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';
import { extLocalStore } from 'util/localStorage';
// eslint-disable-next-line id-match
import { CLOUD_ENV } from 'appConstants';
import config from 'config';

/**
 * This is to imrpove developer experience when switching environments during testing.
 * If the environment in localStorage does not match the env app is currently running
 * we will clear the entire extension's data from localStorage to prevent
 * mismatched environment tokens.
 */
if (config.envShortName !== 'prd') {
	const storedEnv = extLocalStore.getItem(CLOUD_ENV);
	if (storedEnv && !storedEnv.includes(config.envShortName)) {
		// eslint-disable-next-line no-console
		console.log('App loaded in a different env; clearing ext cache.');
		extLocalStore.clear();
	}
}

(async () => {
	const LDProvider = await asyncWithLDProvider({ clientSideID: config.launchDarklyId });
	// eslint-disable-next-line react/no-deprecated
	ReactDOM.render(
		<LDProvider>
			<App />
		</LDProvider>,
		document.getElementById('root')
	);
})();
